var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoHomeSansTexte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "picto_home",
    "data-name": "picto home",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.229,
    height: 48.229,
    viewBox: "-1.500 -4.114 48.229 48.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_157",
    "data-name": "Trac\\xE9 157",
    d: "M1.276,22.349,22.82,1.245,34.757,13.116l-.317-7.877H40V18.132L44,22.466l-1.975,1.976L22.816,5.23,3.537,24.509ZM22.824,0,0,22.358l3.551,3.391L22.816,6.483,42.029,25.7l3.2-3.206-4.35-4.706V4.352H33.517l.263,6.542Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_158",
    "data-name": "Trac\\xE9 158",
    d: "M8.794,27.876,23.823,13.314,38.852,27.877V40.408H29.142V28.519H18.553V40.484H8.832Zm-.753-.506-.135.131L7.948,41.37H19.44V29.406h8.815V41.3H39.739V27.5L23.823,12.08Z",
    transform: "translate(-0.897 -1.37)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoHomeSansTexte);
export default __webpack_public_path__ + "static/media/picto_home_sans_texte.c73fdb81de817463d04f8ee256ead42f.svg";
export { ForwardRef as ReactComponent };